import { render, staticRenderFns } from "./InactivityTimeModal.vue?vue&type=template&id=2ecd3b1b&scoped=true&"
import script from "./InactivityTimeModal.vue?vue&type=script&lang=js&"
export * from "./InactivityTimeModal.vue?vue&type=script&lang=js&"
import style0 from "./InactivityTimeModal.vue?vue&type=style&index=0&id=2ecd3b1b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecd3b1b",
  null
  
)

export default component.exports